import React from 'react';
import styles from './CSSZSickLeavePatientAddressesPicker.module.scss';
import {
	CsszPatientAddressRow,
	formatCsszRegistryAddressRowPreview,
} from '../../Helpers/csszRegistryPatientAddresses.helper';

interface Props {
	item: CsszPatientAddressRow;
	onSelect: (item: CsszPatientAddressRow) => void;
}

const CSSZSickLeavePatientAddressPickerItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	const preview = formatCsszRegistryAddressRowPreview(item);

	return (
		<div className={styles.item} onClick={() => onSelect(item)}>
			<span className={styles.itemLabel}>{preview || '—'}</span>
		</div>
	);
};

export default CSSZSickLeavePatientAddressPickerItem;
